import React from "react";
import { Form } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { DriveSharedInfo, DriveUIActionTypes } from "src/common";
import { ToolbarWrapper } from "src/components";

type AllProps = {
  is_loading: boolean;
  handleAction: ActionHandlerFunction;
  shared_folders: DriveSharedInfo[];
};

function SharedToolbarComponent(props: AllProps) {
  const { is_loading, shared_folders, handleAction } = props;

  function handleOptionSelect(e: React.ChangeEvent<HTMLSelectElement>) {
    const value = e.target.value;
    handleAction({ actionType: DriveUIActionTypes.SetFilter, params: { value } });
  }

  const left_content = (
    <Form.Select size="sm" onChange={handleOptionSelect}>
      <option value={"all"}>All</option>
      <option value={"hidden"}>Hidden</option>
      <option value={"shown"}>In My PreVeil</option>
    </Form.Select>
  );

  return (
    <ToolbarWrapper
      leftContent={left_content}
      paginationInfo={<span className="pagination_info">{shared_folders.length} Items</span>}
      refreshAction={() => handleAction({ actionType: DriveUIActionTypes.Refresh })}
      refreshTooltipContent="Refresh Drive Shared List"
      isLoading={is_loading}
    />
  );
}

export default React.memo(SharedToolbarComponent);
